import { render, staticRenderFns } from "./GroupJoin.vue?vue&type=template&id=2f8c2309"
import script from "./GroupJoin.vue?vue&type=script&lang=js"
export * from "./GroupJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports